import axios from 'axios';
import { backendURL } from './consts';

export const getAllSeminars = async (token, params) => {
  const res = await axios.get(
    `${backendURL}/seminar/`,
    {
      headers:{
        token: `bearer ${token}`,
      },
      params
    }
  )
  return res.data;
}

export const getSeminar = async (token, seminarId) => {
  const res = await axios.get(
    `${backendURL}/seminar/getSeminar?seminarId=${seminarId}`,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  )
  return res.data;
}

export const deleteSeminar = async (token, seminarId) => {
  const res = await axios.delete(
    `${backendURL}/seminar?seminarId=${seminarId}`,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  )
  return res.data;
}

export const createSeminar = async (token, seminar) => {
  const res = await axios.post(
    `${backendURL}/seminar/`,
    seminar,
    {
      headers: {
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}
export const editSeminar = async (token, seminar) => {
  const res = await axios.put(
    `${backendURL}/seminar/`,
    seminar,
    {
      headers: {
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}

export const uploadSeimnarImage = async (token, data) => {
  const res = await axios.post(
    `${backendURL}/seminar/uploadPhoto`,
    data,
    {
      headers: {
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}

export const getSeminarLocations = async (seminarId) => {
  const res = await axios.get(
    `${backendURL}/seminar/getSeminarLocations?seminarId=${seminarId}`
  )
  return res.data;
}

export const syncSeminars = async (token) => {
  const res = await axios.get(
    `${backendURL}/seminar/syncSeminars`,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}

export const getSyncing = async (token) => {
  const res = await axios.get(
    `${backendURL}/seminar/syncActive`,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}